/** development environment variables */
import { configs } from "./config";

/** Production environment variables */
 import { prodConfigs } from "./prod-config";

export const appConfigs = window.location.origin === "http://localhost:3000" ? configs : prodConfigs;
